import React from 'react';
import loadingAnimationData from 'assets/loading.json';
import DefaultFace from './DefaultFace.js';

const LoadingFace = ({ headerText = 'headerText', bodyText = 'bodyText', background }) => {
  return (
    <DefaultFace
      animationData={loadingAnimationData}
      loopAnimation={true}
      headerText={headerText}
      bodyText={bodyText}
      background={background}
    />
  );
};

export default LoadingFace;
